import * as React from 'react';
import { useRouter } from 'next/router';
import Layout from '../../components/Layout';
import EventDetail from '../../components/event/EventDetail';
import { withApollo } from '../../lib/apollo';


const Page = () => {
  const router = useRouter();
  const { slug } = router.query;
  return (
    <Layout>
      <main>
        <EventDetail slug={Array.isArray(slug) ? slug[0] : slug} />
      </main>
    </Layout>
  );
};
export default withApollo(Page);
